<template>
  <CreateSave
      :maxWidth="500"
      :setTitle="setTitle"
      :setItemForm="setItemForm"
      :createData="createData"
      @onCreate="(response) => $emit('onCreate', response)"
      v-bind="$attrs"
  >
    <template
        v-slot:default="{
          errors,
          ItemForm
        }"
    >
      <v-row>
        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.title"
              :error-messages="errors.title"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Názov"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <v-text-field
              v-model="ItemForm.module"
              :error-messages="errors.module"
              :filled="true"
              :dense="true"
              hide-details="auto"
              label="Modul"
          />
        </v-col>
      </v-row>
    </template>
  </CreateSave>
</template>

<script>
  import IndexGroups from '@/services/index-groups'

  import CreateSave from '@/components/_Part/_Modal/_Save/Create'

  export default {
    name: 'Create',
    emits: [
      'onCreate'
    ],
    components: {
      CreateSave
    },
    methods: {
      setTitle() {
        return 'Vytvoriť skupinu číselníkov'
      },
      setItemForm() {
        return {
          title: null,
          module: null
        }
      },
      createData(ItemForm) {
        return IndexGroups
          .create({
            data: ItemForm
          })
      }
    }
  }
</script>
